module.exports = __webpack_public_path__ + "img/BAU_Partners_14.f50c8c30.jpg";